import React from 'react';
import divider from '../../assets/divider-img.png';
import image from '../../assets/backtest-performance.png';

const BacktestPerformance = () => {
  return (
    <div className="backtest-component">
      <div className="container">
        <div className="backtest-main-wrapper backtest-performance-wrapper">
          <div className="backtest-heading-description tab-ml align-c-768">
            <h2>Analyzing Simulated Performance</h2>
            <div className="divider">
              <img src={divider} alt="divider" />
            </div>
            <p>
              Once a strategy is developed, we use backtesting to analyze its
              simulated performance. This helps us refine the strategy and
              optimize its parameters.
            </p>
          </div>
          <div className="backtest-content">
            <img
              className="backtest-performance-image"
              src={image}
              alt="backtest-performance"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default BacktestPerformance;
